// Converts locale names to ISO codes
// https://www.w3schools.com/tags/ref_language_codes.asp
function toISOCode(locale) {
  // Never let a falsy locale produce an invalid/blank <html lang> attribute
  if (!locale) return 'en'
  return locale == 'en-US' ? 'en' : locale
  // switch (locale) {
  //   case 'en-US':
  //     return 'en'
  //   case 'fr':
  //     return 'fr'
  //   case 'es':
  //     return 'es'
  //   default:
  //     throw new Error(`Unknown locale ${locale} has no corresponding ISO code.`)
  // }
}

export default toISOCode
